import { getLocalAccessToken } from "../../utils/helper";
import api, {
  handleErrorCreateAndUpdate,
  handleErrorShowCache,
} from "../../services/api";
import { Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.flfIotPartner;

/*  
   DEVICE FPT LIFE
*/

export const createFLFIotPartner = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const getFLFIotPartner = (params = {}, callback) => {
  api
    .get(URL, { params })
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const updateFLFIotPartner = (id, data, callback) => {
  api
    .patch(`${URL}/${id}`, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

//? remove iot partner
export const removeFLFIotPartner = (id, callback) => {
  api
    .delete(`${URL}/${id}`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const sortFLFIotPartner = (data, callback) => {
  api
    .patch(`${URL}/sort`, data)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getCacheFLFIotPartner = (callback) => {
  api
    .get(`${URL}/cache`)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => {
      handleErrorShowCache(err);
    });
};

export const clearCacheFLFIotPartner = (callback) => {
  api
    .post(`${URL}/clear-cache`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const deployCacheFLFIotPartner = (callback) => {
  api
    .post(`${URL}/deploy-cache`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
